import { ParticipantSubType } from '@collector/sportsapi-client-legacy'

export function canAddParticipantSubTypeToPosition(
  subtype: ParticipantSubType | null | undefined,
  positionKey: PropertyKey,
): boolean {
  // only player who is 'coach' should be added to 'coach' position
  return subtype === ParticipantSubType.Coach
    ? positionKey === 'coach'
    : positionKey !== 'coach'
}
